import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RoleGuardService } from "./auth/role-guard.service";
import { NotFoundComponent, SessionExpiredComponent, UnauthorizeComponent } from "./core";
import { FaqComponent } from "./faq/faq.component";
import { MsalGuard } from "@azure/msal-angular";
import { roles } from "./app.config";
import { ActionComponent } from "./action/action.component";
import { DemoAssetEditorComponent } from "./demo-asset-editor";
import { DemoTemplateEditorComponent } from "./demo-template-editor/demo-template-editor.component";
import { HomeComponent } from "./home/home.component";
import { NewsComponent } from "./news/news.component";
import { AboutComponent } from "./about/about.component";
import { SupportComponent } from "./support/support.component";

const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("./home/home.module").then(m => m.HomeModule),
    component: HomeComponent,
    canActivate: [MsalGuard],
    pathMatch: "full"
  },
  {
    path: "about",
    loadChildren: () => import("./about/about.module").then(m => m.AboutModule),
    component: AboutComponent,
    canActivate: [MsalGuard]
  },
  {
    path: "support",
    loadChildren: () => import("./support/support.module").then(m => m.SupportModule),
    component: SupportComponent,
    canActivate: [MsalGuard]
  },
  {
    path: "faq",
    loadChildren: () => import("./faq/faq.module").then(m => m.FaqModule),
    component: FaqComponent,
    canActivate: [MsalGuard]
  },
  {
    path: "news",
    loadChildren: () => import("./news/news.module").then(m => m.NewsModule),
    component: NewsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: "admin-portal",
    loadChildren: () => import("./admin-portal/admin-portal.module").then(m => m.AdminPortalModule),
    canActivate: [RoleGuardService],
    data: {
      expectedRoles: [roles.SuperUser]
    }
  },
  {
    path: "demo/new",
    component: DemoAssetEditorComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRoles: [roles.SuperUser]
    }
  },
  {
    path: "demo/:id",
    component: DemoAssetEditorComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRoles: [roles.SuperUser]
    }
  },
  {
    path: "template/new",
    component: DemoTemplateEditorComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRoles: [roles.SuperUser]
    }
  },
  {
    path: "template/:id",
    component: DemoTemplateEditorComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRoles: [roles.SuperUser]
    }
  },
  { path: "unauthorize", component: UnauthorizeComponent, canActivate: [MsalGuard] },
  { path: "notfound", component: NotFoundComponent, canActivate: [MsalGuard] },
  { path: "session-expired", component: SessionExpiredComponent },
  {
    path: "action",
    component: ActionComponent,
    canActivate: [MsalGuard]
  },
  { path: "**", component: NotFoundComponent, canActivate: [MsalGuard] }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: "enabledBlocking"
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
